import { Box, Grid, InputAdornment } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { routeName } from 'routes/routes-name';

/** TRANSLATION*/
import { useTranslation } from 'react-i18next';

/** API */
import ClinicApi from 'api/master/clinic.api';
import ReportApi, { FindAllReportInterface } from 'api/report.api';

/** CONSTANT */
import { getBranch } from 'utils/app.utils';

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard';
import { useDownloadExcel } from 'component/Excel/hooks/useExcel';
import InputSecondNewRangePicker from 'component/Input/InputSecondNewRangePicker';
import Loading from 'component/Loading';
import TreatmentRightList from './TreatmentRightList';

/** STYLE */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as UseStyled from 'features/report/useStyled';
import MainButton from 'new-components/buttons/main-button';
import SelectInput from 'new-components/inputs/select-input';
import TextInput from 'new-components/inputs/text-input';


export default function TreatmentRight() {
    const { t } = useTranslation();
    const history = useHistory()
    const componentRef = useRef<HTMLDivElement>(null)
    const emptyRangePicker = ['', '']
    const momentNowRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    const momentDate = () => momentNowRange

    const [branches, setBranches] = useState<any[]>([])
    const [branchId, setBranchId] = useState<any>(getBranch());
    const [treatmentRightData, setTreatmentRightdata] = useState<any[]>([])
    const [exportDataTreatmentRight, setExportDataTreatmentRight] = useState<any[]>([])
    const [rowCountTreatment, setRowCountTreatment] = useState<number>(0)
    const [pageTreatment, setPageTreatment] = useState<number>(1)
    const [pageLimitTreatment, setPageLimitTreatment] = useState<number>(10)
    const [sortBy, setSortBy] = useState<string>('createAt');
    const [sortType, setSortType] = useState<string>('ASC');
    const [rangeDate, setRangeDate] = useState<string[]>(momentDate);
    const [loading, setLoading] = useState<boolean>(false);
    const [search, setSearch] = useState('');
    const [fetch, setFetch] = useState<boolean>(false)
    const verifyPermission = async () => {
        const condition: FindAllReportInterface = {
            page: 1, pageLimit: 200
        }
        ReportApi.reportList(condition)
            .then(({ data }) => {
                const check = _.find(data, (val: any) => String(val.reportKey) === 'TREATMENT_RIGHT_MONTH') ? true : false
                if (!check) {
                    history.push(routeName.report)
                    return false
                }
            })

        ClinicApi.findAllBranches()
            .then(({ data }) => setBranches(data))
            .catch((e) => { return })

        return true
    }

    useEffect(() => {
        verifyPermission()
    }, [])

    const fetchTreatmentRight = useCallback(() => {
        let condition: FindAllReportInterface = {
            page: pageTreatment, pageLimit: pageLimitTreatment, branchId,
        }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (sortBy) condition = { ...condition, sortBy: sortBy }

        if (rangeDate[0] !== null && rangeDate[1] !== null)
            condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
        if (search) condition = { ...condition, search: search }

        ReportApi.reportTreatmentRightMonth(condition)
            .then(({ headers, data }) => {
                setTreatmentRightdata(data.rows)
                setRowCountTreatment(headers['x-total'])
            }).catch((e) => setLoading(false))
            .finally(() => {
                setLoading(false)
                setFetch(false)
            })

    }, [pageTreatment, pageLimitTreatment, sortType, sortBy, fetch])


    const fetchTreatmentRightExport = useCallback(() => {
        let condition: FindAllReportInterface = {
            page: 1, pageLimit: 1000,
            sortType: sortType, sortBy: sortBy, branchId, export: 1
        }
        if (search) condition = { ...condition, search: search }
        if (rangeDate[0] !== null && rangeDate[1] !== null)
            condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }

        ReportApi.reportTreatmentRightMonth(condition)
            .then(({ data }) => {
                setExportDataTreatmentRight(data.rows)
            }).catch((e) => setLoading(false))
            .finally(() => {
                setLoading(false)
                setFetch(false)
            })

    }, [pageTreatment, pageLimitTreatment, sortType, sortBy, fetch])

    const filter = [
        branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')}`,
        rangeDate[0],
        rangeDate[1],
    ]
    const { onDownload } = useDownloadExcel({
        tableExportRef: componentRef.current,
        filename: `${t(`REPORT.REPORT_NAME.TREATMENT_RIGHT_MONTH`)} ${rangeDate[0] ? `(${rangeDate[0]}-${rangeDate[1]})` : ''} `,
        sheetName: `${t(`REPORT.REPORT_NAME.TREATMENT_RIGHT_MONTH`)}`
    })

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangeRowsPerPage = (limit: number) => setPageLimitTreatment(limit)

    const handleChangePage = (val: number) => setPageTreatment(val)

    // UseEffect//
    useEffect(() => {
        fetchTreatmentRight()
    }, [fetchTreatmentRight])

    useEffect(() => {
        fetchTreatmentRightExport()
    }, [fetchTreatmentRightExport])



    return (
        <Box sx={{ height: '100%' }}>
            <HeaderCard text={t('REPORT.REPORT_NAME.TREATMENT_RIGHT_MONTH')} />

            <Box sx={{ px: 3, pt: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPageTreatment(1);
                            }}
                            fullWidth
                            label={t('REPORT.REPORT_NAME.SEARCH_TREATMENT_RIGHT_MONTH')}
                            value={search}
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <SelectInput
                            label={t('REPORT.FILTER.BRANCH')}
                            value={branchId}
                            onChange={e => {
                                setBranchId(Number(e.target.value));
                                setPageTreatment(1);
                            }}
                            options={[
                                { value: 0, name: t(`REPORT.FILTER.ALL`) },
                                ...branches.map(b => ({
                                    value: b.branchId,
                                    name: b.branchName || b.branchNameEn || ''
                                }))]}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} xl={3}>
                        <InputSecondNewRangePicker
                            inputHeight={40}
                            value={rangeDate || emptyRangePicker}
                            onchange={(val) => {
                                if (_.isEmpty(val)) setRangeDate(emptyRangePicker);
                                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]);
                                setPageTreatment(1);
                            }}
                            label=""
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={1} xl={1}>
                        <MainButton
                            title={t('INPUT.SEARCH')}
                            type="primary"
                            variant="contained"
                            onClick={() => {
                                setFetch(true);
                                setPageTreatment(1);
                            }}
                            style={{ width: '120px' }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2} xl={3} sx={{ display: 'flex', justifyContent: 'flex-end', ml: 'auto', pt: 2, px: 1 }}>
                        <UseStyled.DropdownDocument>
                            <Dropdown.Toggle id="dropdown-basic" className="ml-auto">
                                {t('PRINT_DOCUMENT')}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={onDownload}>{t('Excel')}</Dropdown.Item>
                                <Dropdown.Item onClick={() => window.print()}>{t('PDF')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </UseStyled.DropdownDocument>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, px: { xs: 1 }, pb: 4 }}>
                    <TreatmentRightList
                        filter={filter}
                        page={pageTreatment}
                        pageLimit={pageLimitTreatment}
                        rowCount={rowCountTreatment}
                        sortBy={sortBy}
                        sortType={sortType}
                        data={treatmentRightData}
                        onRequestSort={onRequestSort}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        handleChangePage={handleChangePage}
                        componentRef={componentRef}
                        exportData={exportDataTreatmentRight}
                    />
                </Box>
            </Box>

            <Loading show={loading} type="fullLoading" />
        </Box>
    );


}